<template>
  <section :class="blockClass">
    <div class="container">
      <div class="row">
        <div
          class="col-12 col-md-8 services-wheel__intro typography"
          v-if="data.services_copy_position === 'below_title'"
        >
          <ContentArea :content="data" title_field_tag="h2" />
        </div>

        <div
          v-else
          class="services-wheel__intro services-wheel__intro--alongside typography"
        >
          <div class="col-12 col-md-4">
            <h2 v-html="data.content_title"></h2>
          </div>
          <div class="col-12 col-md-8">
            <div v-html="data.content_copy" class="large"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="services-wheel__body" id="services-wheel-body">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="services-wheel__wheel">
              <svg class="services-wheel__wheel__circle" xmlns="http://www.w3.org/2000/svg" width="614.002" height="623.936" viewBox="-40 -40 614.002 623.936">
                  <g class="segment-container">
                      <!--Show Segment-->
                      <g id="Show" @click="slideTo(0)" :class="`segment ${this.active_service_index === 0 ? 'segment--active' : ''}`">
                          <path id="ShowHitbox" fill="transparent" d="M278.656.083C276.443.033 274.231 0 272 0s-4.444.033-6.655.083A271.828 271.828 0 0 0 39.812 130.267l60.969 35.967 98.911 57.836c15.039-22.965 46.48-37.423 73.888-38.974 27.415 1.509 55.675 15.977 70.7 38.96l98.905-57.841 61.005-35.948A271.828 271.828 0 0 0 278.656.083z"/>
                          <g id="Play" class="inner-segment">
                              <path id="PlaySegment" d="M104.535 169.157a196.449 196.449 0 0 1 162.629-93.935l.019 109.865a86.523 86.523 0 0 0-67.491 38.983z"/>
                              <g id="PlayIcon" class="segment-icon">
                                  <path d="M238.563 161.3l-5.172 3.069-.493-.831 4.342-2.576-11.3-19.054-39.54 23.458 11.3 19.054 4.359-2.586.493.83-5.19 3.079-12.29-20.715 41.194-24.439z"/>
                                  <path d="M227.068 174.072l-12.983 7.7-1.324-2.238-2.516-5.616a1.9 1.9 0 0 1 .171-2.129l2.189-3.275 3.661-2.172 3.721-.23a1.9 1.9 0 0 1 1.938.869l3.844 4.9zm-12.645 6.379l11.321-6.717-.79-1.331-3.842-4.9a.929.929 0 0 0-.974-.437l-.062.008-3.518.217-3.272 1.942-2.11 3.153a.926.926 0 0 0-.085 1.065l.025.049 2.515 5.614z"/>
                                  <path d="M236.859 168.263l-10.207 6.056-.493-.831 9.377-5.563-.6-1.014-3.252-3.989a.706.706 0 0 0-.789-.265l-.057.01-3.23.375-3.106 1.843-2.07 2.775a1.269 1.269 0 0 0-.163.227l-.853-.454a1.993 1.993 0 0 1 .271-.385l2.156-2.9 3.449-2.046 3.408-.4a1.662 1.662 0 0 1 1.794.684l3.254 3.992z"/>
                                  <path d="M214.518 181.518l-10.207 6.056-1.145-1.941-1.912-4.7a1.666 1.666 0 0 1 .259-1.9l1.981-2.8 3.449-2.047 3.62-.512a1.677 1.677 0 0 1 .423-.045l-.012.966a.952.952 0 0 0-.231.026l-3.473.494-3.106 1.844-1.913 2.7a.706.706 0 0 0-.146.82l.032.065 1.91 4.7.6 1.014 9.376-5.563z"/>
                                  <path d="M213.819 166.534a4.286 4.286 0 1 1 1.5-5.873 4.285 4.285 0 0 1-1.5 5.873m-3.881-6.542a3.321 3.321 0 1 0 4.551 1.163 3.323 3.323 0 0 0-4.55-1.162"/>
                                  <path d="M225.3 162.825a4.287 4.287 0 1 1 1.5-5.875 4.286 4.286 0 0 1-1.5 5.875m-3.881-6.544a3.321 3.321 0 1 0 4.551 1.162 3.324 3.324 0 0 0-4.55-1.161"/>
                                  <path d="M205.057 174.837a4.287 4.287 0 1 1 1.5-5.874 4.29 4.29 0 0 1-1.5 5.874m-3.881-6.543a3.321 3.321 0 1 0 4.551 1.162 3.324 3.324 0 0 0-4.55-1.161"/>
                              </g>
                              <text>
                                  <textPath href="#PlayDown" startOffset="50%">Play</textPath>
                              </text>
                          </g>
                          <g id="Pulse" class="inner-segment">
                              <path id="PulseSegment" d="M276.778 185.1l-.02-109.864a196.026 196.026 0 0 1 162.633 93.882l-95.114 54.938a86.306 86.306 0 0 0-67.5-38.956"/>
                              <g id="PulseIcon" class="segment-icon">
                                  <path d="M336.525 185.978l-13.452-9.4-.233-1.311 4.752-6.8 1.355-.24 13.353 9.326.24 1.351-4.788 6.856zm-12.492-10.008l12.738 8.9.367-.066 4.289-6.141-.087-.493-12.64-8.83-.5.088-4.252 6.089z"/>
                                  <path d="M326.9 170.382l-21.318-14.888-.207-1.163 12.81-18.342 1.163-.207 32.879 22.963.207 1.162-6.826 9.774-.863-.6 6.576-9.416-.054-.3L319.1 136.9l-.3.054-12.311 17.628.054.3 20.957 14.637z"/>
                                  <path d="M318.28 168.174h5.068v1.053h-5.068z"/>
                                  <path d="M317.744 162.484h1.053v15.064h-1.053z"/>
                                  <path d="M346.456 191.064l-8.772-6.126.6-.863 8.414 5.876.613-.109 8.089-11.579-.108-.613-16.829-11.75-.613.109-4.263 6.1-.863-.6 4.512-6.462 1.472-.262 17.544 12.252.261 1.472-8.586 12.3z"/>
                                  <path d="M340.69 181.683h16.063v1.053H340.69z"/>
                                  <path d="M349.736 182.836h1.053v.905h-1.053z"/>
                                  <path d="M338.014 180.879h1.053v.692h-1.053z"/>
                                  <path d="M329.213 154.21l-2.152 3.082 3.387.072z"/>
                              </g>
                              <text>
                                  <textPath href="#PulseDown" startOffset="50%">Pulse</textPath>
                              </text>
                          </g>
                          <g class="outer-segment" style="filter:url(#DropShadow);">
                              <path id="ShowSegment" d="M39.812 130.267A271.828 271.828 0 0 1 265.345.083C267.556.033 269.769 0 272 0s4.443.033 6.656.083a271.828 271.828 0 0 1 225.531 130.184l-57.214 33.044c-60.045-96.635-187.059-126.3-283.694-66.252a206 206 0 0 0-66.253 66.252z"/>
                              <text baseline-shift="-4px">
                                  <textPath href="#ShowDown" startOffset="50%">Show</textPath>
                              </text>
                          </g>
                      </g>
                      
                      <!--Enrich Segment-->
                      <g id="Enrich" @click="slideTo(1)" :class="`segment ${this.active_service_index === 1 ? 'segment--active' : ''}`">
                          <path id="EnrichHitbox" fill="transparent" d="M510.861 141.781l-61.951 34.347-99.832 56.243c12.4 24.493 10.813 56.2-1.584 80.7-15.034 22.962-43.268 42.97-70.67 44.516l.625 113.315 1.2 73.034a271.822 271.822 0 0 0 225.54-130.185q3.473-5.668 6.672-11.53a272.4 272.4 0 0 0 0-260.44z"/>
                          <g id="Discover" class="inner-segment">
                              <path id="DiscoverSegment" d="M349.093 310.3l-.006-.01a86.258 86.258 0 0 0-.009-77.922l95.114-54.938a196 196 0 0 1 .052 187.773z"/>
                              <g id="DiscoverIcon" class="segment-icon">
                                  <path d="M399.932 268.571A13.431 13.431 0 1 1 381.2 265.4a13.431 13.431 0 0 1 18.732 3.168M378.96 283.48a12.3 12.3 0 1 0 2.9-17.152 12.3 12.3 0 0 0-2.9 17.152"/>
                                  <path d="M388.698 260.446h5.759v1.131h-5.759z"/>
                                  <path d="M388.416 268.636h1.132v15.435h-1.132z"/>
                                  <path d="M385.334 270.827h1.132v15.435h-1.132z"/>
                                  <path d="M391.498 266.444h1.132v15.435h-1.132z"/>
                                  <path d="M396.755 241.379l1.032 1.451-2.8 16.6-5.881-.994 2.8-16.6 1.452-1.031zm-.162 1.725l-.489-.688-2.474-.416-.688.489L390.4 257.5l3.65.617z"/>
                              </g>
                              <text>
                                  <textPath href="#DiscoverUp" startOffset="50%">Discover</textPath>
                              </text>
                          </g>
                          <g id="Access" class="inner-segment">
                              <path id="AccessSegment" d="M276.843 467.452l-.019-109.865a86.473 86.473 0 0 0 67.476-38.971l95.157 54.913a196.386 196.386 0 0 1-162.609 93.923"/>
                              <g id="AccessIcon" class="segment-icon">
                                  <path d="M353.621 378.764l-1-.164a5.484 5.484 0 0 0-4.523-6.3l.164-1a6.5 6.5 0 0 1 5.367 7.463"/>
                                  <path d="M357 379.317l-1-.164a8.908 8.908 0 0 0-7.352-10.229l.164-1a9.926 9.926 0 0 1 8.192 11.4"/>
                                  <path d="M360.379 379.869l-1-.164a12.331 12.331 0 0 0-10.178-14.16l.164-1a13.348 13.348 0 0 1 11.018 15.329"/>
                                  <path d="M337.475 392.136l-13.329 9.512-1.2-.2-6-8.347.2-1.206 13.3-9.557 1.206.2 6.032 8.391zm-13.579 8.44l12.643-9.022.061-.373-5.539-7.707-.374-.061-12.612 9.066-.061.373 5.507 7.663z"/>
                                  <path d="M352.872 381.069l-11.015 7.85-1.2-.2-6-8.347.2-1.206 10.985-7.9.594.827-10.642 7.649-.061.374 5.507 7.662.375.062 10.674-7.607z"/>
                                  <path d="M348.184 380.585l-1.289.926-3.506-4.878 1.424-1.024a2.662 2.662 0 0 1 4.113.678 3.049 3.049 0 0 1 .675 2.316 3.184 3.184 0 0 1-1.417 1.982m-1.046-.362l.5-.359a1.868 1.868 0 0 0 .848-2.5 1.848 1.848 0 0 0-.348-.488 1.8 1.8 0 0 0-2.869-.477l-.581.417z"/>
                                  <path d="M340.614 378.6l5.441 3.516-.844.606-1.733-1.117-1.478 1.062.5 2-.84.6-1.558-6.306zm1.145 3.117l.907-.652-1.294-.86z"/>
                                  <path d="M326.757 396.077a2.574 2.574 0 0 1-2.126.5 3.292 3.292 0 0 1-1.91-1.406 3.56 3.56 0 0 1-.648-1.491 2.574 2.574 0 0 1 .185-1.482 2.975 2.975 0 0 1 1.006-1.2 3.6 3.6 0 0 1 1.445-.639l.274-.05.193.931-.294.047a2.5 2.5 0 0 0-1.068.439 1.765 1.765 0 0 0-.808 1.271 2.326 2.326 0 0 0 .517 1.6 2.43 2.43 0 0 0 1.341 1.033 1.69 1.69 0 0 0 1.429-.356 3.988 3.988 0 0 0 .858-.818l.233-.306.538.748-.115.166a4.372 4.372 0 0 1-1.05 1.008"/>
                                  <path d="M331.341 392.782a2.574 2.574 0 0 1-2.126.5 3.292 3.292 0 0 1-1.91-1.406 3.56 3.56 0 0 1-.648-1.491 2.574 2.574 0 0 1 .185-1.482 2.975 2.975 0 0 1 1.006-1.2 3.594 3.594 0 0 1 1.446-.639l.273-.05.193.931-.294.047a2.5 2.5 0 0 0-1.067.439 1.764 1.764 0 0 0-.809 1.271 2.326 2.326 0 0 0 .517 1.6 2.43 2.43 0 0 0 1.341 1.033 1.69 1.69 0 0 0 1.429-.356 3.988 3.988 0 0 0 .858-.818l.233-.306.538.748-.115.166a4.372 4.372 0 0 1-1.05 1.008"/>
                                  <path d="M326.271 381.9a6.895 6.895 0 0 1-10.679-3.833l-1.836-6.68.785-.211a2.72 2.72 0 0 1 1.809.143l-1.186-4.4a4.017 4.017 0 0 0 2.342-3.312 4.463 4.463 0 0 0 3.7-.89 1.788 1.788 0 0 1 2.2 1.24l.254.942a1.788 1.788 0 0 1 2.892.892l2.356 8.737a6.9 6.9 0 0 1-2.645 7.371M315 372.119l1.563 5.684a5.875 5.875 0 0 0 11.394-2.87 3.193 3.193 0 0 0-.037-.14l-2.355-8.734a.771.771 0 1 0-1.492.39l1 3.721-.982.265-1-3.71v-.017l-.662-2.454a.776.776 0 0 0-.37-.484.761.761 0 0 0-.585-.07.772.772 0 0 0-.535.95l1.668 6.186-.983.265-1.669-6.19v-.017l-.16-.593a.771.771 0 1 0-1.5.376l.006.024 1.833 6.8-.983.265-1.488-5.522a.814.814 0 0 0-.394-.52.792.792 0 0 0-1.137.92l2.325 8.622-.983.265-.584-2.167a1.719 1.719 0 0 0-1.889-1.247"/>
                                  <path d="M334.4 372.565a6.878 6.878 0 0 1-4.584 1.267l.083-1.014a5.86 5.86 0 0 0 5.442-2.709l4.817-7.655a.775.775 0 0 0-.826-1.172.758.758 0 0 0-.479.344l-2.048 3.256-.862-.542 3.41-5.42a.771.771 0 1 0-1.308-.817l-3.407 5.416-.861-.542 3.75-5.961a.771.771 0 0 0-1.26-.889.969.969 0 0 0-.04.063l-3.752 5.966-.862-.542 3.043-4.839a.791.791 0 1 0-1.339-.843l-3.537 5.622-.016.026-1.2 1.9-.862-.542 1.209-1.922a1.723 1.723 0 0 0-.382-2.214l-2.955 4.655-.859-.545 3.5-5.522.683.429a2.716 2.716 0 0 1 1.123 1.427l2.427-3.857a3.867 3.867 0 0 0 4.014-.536 3.331 3.331 0 0 1 3.751 4.6l-.5.8a1.789 1.789 0 0 1 1.314 2.718l-4.83 7.678a6.917 6.917 0 0 1-1.8 1.912"/>
                              </g>
                              <text>
                                  <textPath href="#AccessUp" startOffset="50%">Access</textPath>
                              </text>
                          </g>
                          <g class="outer-segment">
                              <path id="EnrichSegment" d="M278.654 543.936V477.8c110.67-3.5 199.3-94.317 199.3-205.835a204.837 204.837 0 0 0-24.326-97.145l57.233-33.042a272.4 272.4 0 0 1 0 260.44q-3.2 5.862-6.672 11.53a271.822 271.822 0 0 1-225.535 130.188"/>
                              <text>
                                  <textPath href="#EnrichUp" startOffset="50%">Enrich</textPath>
                              </text>
                          </g>
                      </g>

                      <!--Supply Segment-->
                      <g id="Supply" @click="slideTo(2)" :class="`segment ${this.active_service_index === 2 ? 'segment--active' : ''}`">
                          <path id="SupplyHitbox" fill="transparent" d="M197.326 314.478c-12.4-24.5-14.808-57.588-2.417-82.09l-99.847-56.24L33.14 141.78a272.411 272.411 0 0 0 0 260.439q3.2 5.863 6.672 11.53a271.818 271.818 0 0 0 225.536 130.184l.946-71.311.932-115.034c-27.414-1.511-54.876-20.129-69.9-43.11z"/>
                          <g id="Connect" class="inner-segment">
                              <path id="ConnectSegment" d="M99.811 365.26a196.031 196.031 0 0 1-.059-187.785l95.157 54.913a86.311 86.311 0 0 0 .016 77.934z"/>
                              <g id="ConnectIcon" class="segment-icon">
                                  <path d="M166.004 271.069h.923v14.941h-.923z"/>
                                  <path d="M135.131 279.354l-2.147-13.463 16.1 4.335zm-1.012-12.2l1.7 10.651 11.04-7.222z"/>
                                  <path d="M132.411 273.06h11.414v.923h-11.414z"/>
                                  <path d="M137.177 264.798h.922v11.413h-.922z"/>
                                  <path d="M144.382 282.663a16.2 16.2 0 0 1 13.479-18.15 13.172 13.172 0 0 1 10.41 2.79l.356.293-19.333 23.459-.356-.293a13.052 13.052 0 0 1-4.556-8.1m22.941-14.935a12.3 12.3 0 0 0-9.33-2.3 14.963 14.963 0 0 0-9.364 5.385c-4.9 5.945-4.62 14.334.546 18.939z"/>
                                  <path d="M162.752 276.701h.922v11.39h-.922z"/>
                                  <path d="M151.933 286.044h15.727v.923h-15.727z"/>
                                  <path d="M168.7 287.154a1.442 1.442 0 0 0-.153-2.034l-1.1-.942-1.881 2.192 1.1.942a1.445 1.445 0 0 0 2.037-.155"/>
                              </g>
                              <text>
                                  <textPath href="#ConnectUp" startOffset="50%">Connect</textPath>
                              </text>
                          </g>
                          <g id="Reach" class="inner-segment">
                              <path id="ReachSegment" d="M104.612 373.572l95.114-54.938a86.322 86.322 0 0 0 67.5 38.954l.014 109.854a196 196 0 0 1-162.626-93.87"/>
                              <g id="ReachIcon" class="segment-icon">
                                  <path d="M215.039 389.057L194.666 377.3a8.311 8.311 0 0 1 8.3-14.4c.053.03.1.062.156.1a9.278 9.278 0 0 1 15.058 7.551 6.665 6.665 0 0 1 1.08.494 7.34 7.34 0 0 1 2.689 10.014 6.418 6.418 0 0 1-.377.577 5.043 5.043 0 0 1-6.537 7.418m-10.068-6.894l10.539 6.077a4.1 4.1 0 0 0 5.113-6.276l-.262-.3.245-.31a6.317 6.317 0 0 0-3.055-10.024l-.352-.113.026-.368a8.335 8.335 0 0 0-13.76-6.906l-.271.233-.4-.263c-.1-.066-.2-.132-.3-.192a7.368 7.368 0 0 0-7.361 12.766z"/>
                                  <path d="M198.255 391.354l-1.879-7 .911-.245 1.634 6.089 6.088-1.635.245.911z"/>
                                  <path d="M193.032 380.688h22.203v.943h-22.203z"/>
                                  <path d="M210.98 378.209l-1.635-6.088-6.088 1.635-.244-.911 7-1.88 1.879 7z"/>
                              </g>
                              <text>
                                  <textPath href="#ReachUp" startOffset="50%">Reach</textPath>
                              </text>
                          </g>
                          <g class="outer-segment">
                              <path id="SupplySegment" d="M0 272a270.831 270.831 0 0 1 33.14-130.22l57.231 33.041a204.887 204.887 0 0 0-24.323 97.145c0 111.518 88.628 202.34 199.3 205.835v66.132A271.818 271.818 0 0 1 39.812 413.749q-3.468-5.666-6.672-11.53A270.729 270.729 0 0 1 0 272"/>
                              <text>
                                  <textPath href="#SupplyUp" startOffset="50%">Supply</textPath>
                              </text>
                          </g>
                      </g>

                      <!-- centreLogo -->
                      <g id="CentreLogo" transform="translate(0 -1)">
                          <path id="Background" d="M350.317,271.968A78.316,78.316,0,1,1,272,193.652a78.316,78.316,0,0,1,78.316,78.316h0" fill="#dc281e"/>
                          <path id="RedBee" d="M245.64,245.2a8.268,8.268,0,0,0-2.044-.214h-7.708v7.482h7.647a8.909,8.909,0,0,0,1.988-.194,3.679,3.679,0,0,0,.115-7.074m1.865,24.02L241.99,257.9h-6.1v11.31h-6.164v-29.8h13.722a16.257,16.257,0,0,1,5.256.678,8.59,8.59,0,0,1,6.207,8.668c0,4.305-2.441,7.324-6.462,8.7l6.273,11.749Zm53.841-23.769a12.546,12.546,0,0,0-2.762-.229H295.67v18.214h2.692a11.991,11.991,0,0,0,3.039-.3c4.206-1.078,6.151-4.542,6.151-8.928,0-4.562-2.036-7.818-6.209-8.762m2.977,23.031a24.8,24.8,0,0,1-7.117.742h-7.684v-29.8h7.689a24.4,24.4,0,0,1,7.18.842c6.253,2.11,9.888,7.318,9.888,14.062,0,6.768-3.635,12.1-9.956,14.149m-43.465-29.051h21.47V245.3h-21.47Zm0,11.964h21.47v5.877h-21.47Zm0,11.952h21.47v5.883h-21.47ZM243.79,292.615h-7.942v6.831h7.94c2.664,0,4.276-1.27,4.276-3.469,0-2.075-1.612-3.362-4.276-3.362m-.36-11.636h-7.58v6.364h7.761a3.179,3.179,0,0,0,3.466-2.864,3.341,3.341,0,0,0,.012-.4c0-1.872-1.135-3.1-3.659-3.1m11.291,15.144c0,4.826-2.749,7.752-7.215,8.658a21.245,21.245,0,0,1-4.368.323h-13.41V275.313H243.5a17.99,17.99,0,0,1,4.279.415c3.69.975,5.886,3.572,5.886,7.455,0,3.5-1.722,5.575-3.7,6.441a6.912,6.912,0,0,1,4.756,6.5m6.136-20.833h21.47v5.882h-21.47Zm0,11.971h21.47v5.87h-21.47Zm0,11.953h21.47v5.88h-21.47Zm50.129-18.042V275.3H289.519v5.87h0v6.1h0v5.858h0v6.1h0V305.1h21.465v-5.868H295.671v-6.1h15.313v-5.854H295.671v-6.1Z" fill="#fff"/>
                      </g>
                  </g>
                  
                  <defs id="Paths">
                      <g id="Outer">
                          <path id="EnrichDown" d="M281.038 501.245c121.2-4.4 218.109-104.039 218.109-226.315a225.464 225.464 0 0 0-26.97-107.276"/>
                          <path id="ShowDown" d="M80.891 154.447a226.531 226.531 0 0 1 384.331 1.2"/>
                          <path id="SupplyDown" d="M73.861 166.412A225.454 225.454 0 0 0 46.216 274.93c0 123.226 98.418 223.464 220.937 226.4"/>
                          <path id="EnrichUp" d="M282.037 528.3c135.689-4.921 244.179-116.473 244.179-253.365a252.416 252.416 0 0 0-30.193-120.1"/>
                          <path id="ShowUp" d="M57.967 140.049a253.607 253.607 0 0 1 430.269 1.341"/>
                          <path id="SupplyUp" d="M50.1 153.445a252.409 252.409 0 0 0-30.953 121.489c0 137.955 110.182 250.175 247.345 253.461"/>
                      </g>
                      <g id="Inner">
                          <path id="PulseUp" d="M277.433 95.489a174.976 174.976 0 0 1 142.316 83.953"/>
                          <path id="PlayUp" d="M121.042 178.633c30.1-48.807 84.6-81.72 145.788-83.238"/>
                          <path id="ConnectUp" d="M115.708 187.905a175.335 175.335 0 0 0 .9 166.633"/>
                          <path id="ReachUp" d="M122.007 363.7a174.938 174.938 0 0 0 143.813 81.7q.56.014 1.121.023"/>
                          <path id="AccessUp" d="M277.5 445.3a174.963 174.963 0 0 0 141.326-82.45"/>
                          <path id="DiscoverUp" d="M424.172 353.653a175.349 175.349 0 0 0 .833-164.962"/>
                          <path id="PulseDown" d="M276.765 111.53a158.931 158.931 0 0 1 129.264 76.254"/>
                          <path id="PlayDown" d="M134.716 187.05c27.34-44.332 76.843-74.226 132.418-75.605"/>
                          <path id="ConnectDown" d="M129.871 195.471a159.252 159.252 0 0 0 .816 151.352"/>
                          <path id="ReachDown" d="M135.592 355.145a158.9 158.9 0 0 0 130.625 74.2c.339.008.679.016 1.019.022"/>
                          <path id="AccessDown" d="M276.824 429.257a158.915 158.915 0 0 0 128.365-74.888"/>
                          <path id="DiscoverDown" d="M410.047 346.018a159.268 159.268 0 0 0 .756-149.833"/>
                      </g>
                  </defs>
                  <defs>
                      <filter id="DropShadow">
                          <feDropShadow dx="0" dy="3" stdDeviation="15" flood-color="black" flood-opacity="0.18" />
                      </filter>
                  </defs>
              </svg>
            </div>
          </div>

          <div class="col-12 col-md-6 services-wheel__content typography">
            <div class="col-12 col-md-6 services-wheel__content__nav">
              <button
                @click.stop="previousSegment"
                class="services-wheel__content__nav__button services-wheel__content__nav__button--prev"
              >
                <svg
                  id="icon_-_arrow_left_01"
                  data-name="icon - arrow left 01"
                  xmlns="http://www.w3.org/2000/svg"
                  width="5.918"
                  height="9.492"
                  viewBox="0 0 5.918 9.492"
                >
                  <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M11.074-13.5,6.328-8.75,11.074-4l1.172-1.172L8.672-8.75l3.574-3.574Z"
                    transform="translate(-6.328 13.496)"
                    fill="#fff"
                  />
                </svg>
              </button>
              <button
                @click.prevent="nextSegment"
                class="services-wheel__content__nav__button services-wheel__content__nav__button--next"
              >
                <svg
                  id="icon_-_arrow_left_01"
                  data-name="icon - arrow left 01"
                  xmlns="http://www.w3.org/2000/svg"
                  width="5.918"
                  height="9.492"
                  viewBox="0 0 5.918 9.492"
                >
                  <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M11.074-13.5,6.328-8.75,11.074-4l1.172-1.172L8.672-8.75l3.574-3.574Z"
                    transform="translate(-6.328 13.496)"
                    fill="#fff"
                  />
                </svg>
              </button>
            </div>

            <ContentArea
              :content="currentService"
              prefix=""
              title_field_tag="h3"
            ></ContentArea>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import slugify from "slugify";
import ContentArea from "./ContentArea";

export default {
  name: "ServicesWheel",
  components: { ContentArea },
  data: function() {
    return {
      data: window.services_wheel,
      active_service_index: 0,
      pointer_index: 0,
      current_wheel_rotation: 0,
      hover_segment_index: 0
    };
  },
  computed: {
    blockClass() {
      let blockClass = "services-wheel";
      if (this.data.background_colour) {
        blockClass += " block--background-" + this.data.background_colour;
      }
      return blockClass;
    },
    currentService() {
      return this.data.services[this.active_service_index];
    },
    currentIcon() {
      if (this.currentService.service_icon) {
        return this.currentService.service_icon.sizes.thumbnail;
      } else {
        return null;
      }
    },
    pointerStyle() {
      let degreesRotate = this.degreesPerSegment() * this.pointer_index;
      return {
        transform: "rotate(" + degreesRotate + "deg)"
      };
    },
    hoverStyle() {
      let degreesRotate = this.degreesPerSegment() * this.hover_segment_index;
      return {
        transform: "rotate(" + degreesRotate + "deg)"
      };
    },
    serviceCount() {
      return this.data.services.length;
    }
  },
  methods: {
    /**
     * Convert a string to a slug
     * @param string
     * @returns {string}
    */
    slugify(string) {
      return slugify(string.toLowerCase());
    },
    previousSegment() {
      if (this.active_service_index === 0) {
        this.active_service_index = this.serviceCount - 1;
      } else {
        --this.active_service_index;
      }
      --this.pointer_index;
    },
    nextSegment() {
      if (this.active_service_index === this.serviceCount - 1) {
        this.active_service_index = 0;
      } else {
        ++this.active_service_index;
      }
      ++this.pointer_index;
    },
    slideTo(val) {
      this.active_service_index = val;
    }
  }
};
</script>

<style lang="scss">
.services-wheel {
  .container {
    padding: {
      top: 0;
      bottom: 0;
    }
  }
  &__intro {
    padding: 64px 15px 23px;
    @media screen and (max-width: 992px) {
      padding: 30px 15px 0px;
    }
    &--alongside {
      display: flex;
      @media screen and (max-width: 767px) {
        display: block;
      }
    }
  }

  &__body {
    /*padding-bottom: 64px;*/
    @media screen and (max-width: 767px) {
      /*padding-bottom: 30px;*/
    }
  }

  &__wheel {
    position: relative;

    &__circle{
      width: 100%;
      transform: scale(1.1) translateY(-50px);

      .segment{
        fill: #fff;
        cursor: pointer;
        transition: fill 0.1s ease;
        filter: url(#DropShadow);

        .outer-segment {
          textPath {
            fill: #dc281e;
            font: 48px 'Open Sans', sans-serif;
            text-anchor: middle;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            transition: fill 0.1s ease;
          }
        }

        .inner-segment {
          textPath {
            fill: #dc281e;
            font: 20px 'Open Sans', sans-serif;
            text-anchor: middle;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            transition: fill 0.1s ease;
          }
        }

        .segment-icon {
          fill: #dc281e;
          transition: fill 0.1s ease;
        }

        &--active,
        &:hover {
          fill: #dc281e;
          .outer-segment textPath,
          .inner-segment textPath {
            fill: #fff;
          }
    
          .segment-icon {
            fill: #fff;
          }
        }
      }

      @media screen and (max-width: 767px) {
        transform: none;
        height: auto;
        margin-top: 2rem;
      }
    }
  }

  &__content {
    position: relative;
    margin-top: 23px;

    &__nav {
      position: relative;
      top: 0;
      left: -20px;
      width: 81px;
      height: 40px;
      display: flex;

      &__button {
        height: 40px;
        background-color: #dc281e;
        flex: 0 0 40px;
        margin-right: 1px;
        cursor: pointer;
        border: 0px;
        display: flex;
        align-items: center;
        justify-content: space-around;

        &--hover {
          background-color: white;
          border: 1px solid #dc281e;

          path {
            border: 1px solid red;
            fill: #dc281e;
          }
        }

        &--next {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }

    .contentarea {
      padding-top: 32px;

      &__copy{
        &--newcontent{
          margin-bottom: 22px;
          a{
            display: flex;
            align-items: center;
            transition: .2s ease-in-out;
            h1{
              margin: 0 10px;
              color: #dc281e;
              transition: .2s ease-in-out;
            }

            &:hover{
              h1{
                color: #323232;
              }
            }
          }

          p{
            font-size: 14px;
            line-height: 20px;
            color: #646464;
          }
        }
      }

      @media screen and (max-width: 767px) {
        padding-top: 28px;
      }
    }
  }
}
</style>
